import BaseAPI, { MAX_LIST_LIMIT } from "./BaseAPI";
import { trainingRecordRoute } from "../routes";

export default class TrainingRecordAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, trainingRecordRoute, "training-record");
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }
}
